export default "__VITE_ASSET__3e16c561__"